import { useConfirm } from "material-ui-confirm";
import DeleteIconButton from "../../../common/components/icons/DeleteIconButton";
import confirmDialogStyleOptions from "../../../common/helpers/confirmDialogParams";
import { useDeleteDeviceTemplate } from "../../system-settings/tabs/devices/hooks/useDeleteDeviceTemplate";

interface DeviceTemplateTableRow {
  id?: string;
  rowId: string;
  name?: string;
  templateData?: string;
  numberOfNodes?: number;
}

interface DeleteTemplateContainerProps {
  row: DeviceTemplateTableRow;
}

const DeleteTemplateContainer = ({
  row,
}: DeleteTemplateContainerProps): JSX.Element => {
  const confirm = useConfirm();

  const { deleteDeviceTemplate, loading } = useDeleteDeviceTemplate();

  const handleRowClick = (): void => {
    confirm({
      title: `Are you sure you want to delete ${row?.name}?`,
      confirmationText: "Delete",
      cancellationText: "Cancel",
      ...confirmDialogStyleOptions,
      confirmationButtonProps: {
        ...confirmDialogStyleOptions.confirmationButtonProps,
        disabled: loading,
      },
    }).then(async (): Promise<void> => {
      if (row.id) {
        await deleteDeviceTemplate(row.id.toString());
      } else {
        console.warn("Tried to delete a row without an ID.");
      }
    });
  };

  return <DeleteIconButton onClick={handleRowClick} />;
};

export default DeleteTemplateContainer;
